import styled from "@emotion/styled";
import Input from "metabase/core/components/Input";

export const QuestionPickerRoot = styled.div`
  padding: 1rem;
`;

export const BreadcrumbsWrapper = styled.div`
  margin-bottom: 0.5rem;
  padding-left: 0.5rem;
`;

export const SearchInput = styled(Input)`
  margin-bottom: 1rem;
`;
